<template>
  <IdeologicalCourses  :courses="courses" :viewCourse="viewCourse" :flag="flag" class="ideologicalCoursesContent"/>
</template>

<script>
import { ideologicalCourses3 } from "@/api/mock.js";
import IdeologicalCourses from "@/components/ideologicalCourses/ideologicalCourses.vue"
export default {
  name: "ideologicalCourses",
  data() {
    return {
      courses: [],
      flag:false
    };
  },
  created() {
    ideologicalCourses3()
      .then(res => {
        // 返回数据
        this.courses = res.list;
      })
      .catch(err => {
        // 异常情况
        console.log(err);
      });
  },
  methods: {
    viewCourse(item) {
      window.open(
        `https://www.ulearning.cn/ulearning_web/web!courseDetail.do?courseID=${item.id}`
      );
    }
  },
  components:{
    IdeologicalCourses
  }
};
</script>

<style scoped>
.ideologicalCoursesContent{
  padding-top: 55px;
  padding-bottom: 50px;
}
.content {
  margin-top: 30px;
  margin-bottom: 50px;
}

.course-item {
  position: relative;
  margin-bottom: 30px;
  background-color: #fff;
}

.course-item .cover {
  position: absolute;
  width: 345px;
  height: 194px;
  background-color: #eee;
}

.course-item .course-info {
  min-height: 122px;
  padding: 36px 36px 36px 375px;
}

.course-item .view-btn {
  position: absolute;
  top: 32px;
  right: 36px;
  width: 88px;
}

.course-item h1 {
  height: 24px;
  line-height: 24px;
  font-size: 18px;
  overflow: hidden;
}

.course-item .introduction {
  margin-top: 26px;
  height: 72px;
  line-height: 24px;
  font-size: 14px;
  color: #888;
  overflow: hidden;
}

@media (max-width: 767px) {
  .ideologicalCoursesContent{
  padding-top:30px;
  padding-bottom: 0px;
}
  .content {
    margin-top: 6px;
    margin-bottom: 30px;
  }

  .course-item {
    margin-bottom: 0;
    padding: 14px 0;
    background-color: unset;
    border-top: 1px solid #eee;
  }

  .course-item.first {
    border-top: unset;
  }

  .course-item .cover {
    width: 142px;
    height: 80px;
  }

  .course-item .course-info {
    min-height: 80px;
    padding: 0 0 0 154px;
  }

  .course-item h1 {
    height: 40px;
    line-height: 20px;
    font-size: 14px;
  }

  .course-item .introduction {
    margin-top: 8px;
    height: 32px;
    line-height: 16px;
    font-size: 12px;
  }
}
</style>
